export default __webpack_public_path__ + "static/media/back.253e440d.svg";